import React from 'react';

import { MAP_THUMB_STATE_TO_ICON } from '../constants';
import { useFeedbackFormContext } from '../Form/FeedbackFormContext';
import { Thumb as ThumbWrapper } from '../Form/Form.styled';
import { theme } from '@/theme.prusaUi';

/**
 * @todo translate
 */
const ThumbImage = ({ thumbState, voteType }) => {
  const IconComponent =
    MAP_THUMB_STATE_TO_ICON[
      `${voteType}${thumbState === voteType ? '_filled' : ''}`
    ];
  return <IconComponent stroke={theme.colors.brand} fill={theme.colors.brand} />;
};

/**
 * @todo rename setUnfoldState
 */
export default function Thumb({ voteType }) {
  const { thumbState, setThumbState, openAction } = useFeedbackFormContext();

  const onClickAction = React.useCallback(() => {
    if (thumbState !== voteType) {
      setThumbState(voteType);
      openAction();
    }
  }, [thumbState, voteType]);

  return (
    <ThumbWrapper onClick={onClickAction} $active={thumbState === voteType}>
      <ThumbImage thumbState={thumbState} voteType={voteType} />
    </ThumbWrapper>
  );
}
